import {
  CoursesViewActions,
  ECoursesViewActions,
} from '@myStore/courses-view/courses-view.actions';
import {
  ICoursesViewState,
  initialCoursesViewState,
} from '@myStore/courses-view/courses-view.state';

export const coursesViewReducers = (
  state = initialCoursesViewState,
  actions: CoursesViewActions
): ICoursesViewState => {
  switch (actions.type) {
    case ECoursesViewActions.GetCoursesRequest:
      return {
        ...state,
        isLoading: true,
      };
    case ECoursesViewActions.GetCoursesSuccess:
      return {
        ...state,
        isLoading: false,
        list: { ...state.list, courses: actions.courses },
      };
    case ECoursesViewActions.GetCoursesFailure:
      return {
        ...state,
        isLoading: false,
      };
    case ECoursesViewActions.ClearCourses:
      return {
        ...state,
        list: null,
        errors: null,
      };

    case ECoursesViewActions.GetCourseDetailRequest:
      return {
        ...state,
        detail: {
          ...state.detail,
          isLoading: true,
        },
      };
    case ECoursesViewActions.GetCourseDetailSuccess:
      return {
        ...state,
        detail: {
          ...state.detail,
          data: actions.course,
          isLoading: false,
        },
      };
    case ECoursesViewActions.GetCourseDetailFailure:
      return {
        ...state,
        detail: {
          ...state.detail,
          isLoading: false,
          errors: actions.error,
        },
      };
    case ECoursesViewActions.ClearCourseDetail:
      return {
        ...state,
        detail: {
          ...state.detail,
          data: null,
          errors: null,
        },
      };
    case ECoursesViewActions.GetActiveCoursesRequest:
      return {
        ...state,
        isLoading: true,
      };
    case ECoursesViewActions.GetActiveCoursesSuccess:
      return {
        ...state,
        isLoading: false,
        list: actions.courses,
      };
    case ECoursesViewActions.GetActiveCoursesFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.error,
      };
    case ECoursesViewActions.ClearActiveCourses:
      return {
        ...state,
        list: null,
        errors: null,
      };
    case ECoursesViewActions.GetInactiveCoursesRequest:
      return {
        ...state,
        isLoading: true,
      };
    case ECoursesViewActions.GetInactiveCoursesSuccess:
      return {
        ...state,
        isLoading: false,
        list: actions.courses,
      };
    case ECoursesViewActions.GetInactiveCoursesFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.error,
      };

    case ECoursesViewActions.SetCurrentCourseId:
      return {
        ...state,
        currentCourseId: actions.payload,
      };

    default:
      return state;
  }
};
